import { render, staticRenderFns } from "./PressEntry.vue?vue&type=template&id=0df5461f&lang=pug&"
import script from "./PressEntry.vue?vue&type=script&lang=js&"
export * from "./PressEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports